import { render, staticRenderFns } from "./addplate.vue?vue&type=template&id=6a64b214&scoped=true"
import script from "./addplate.vue?vue&type=script&lang=js"
export * from "./addplate.vue?vue&type=script&lang=js"
import style0 from "./addplate.vue?vue&type=style&index=0&id=6a64b214&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a64b214",
  null
  
)

export default component.exports